"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteCustomerResponse = exports.UpdateCustomerResponse = exports.UpdateCustomerRequest = exports.GetCustomerQuery = exports.GetCustomerResponse = exports.CustomerDetailsParams = exports.GetCustomersResponse = exports.CustomerSchema = exports.GetCustomersQuery = exports.CreateCustomerResponse = exports.CreateCustomerRequest = void 0;
const zod_1 = require("zod");
const address_types_1 = require("./address.types");
exports.CreateCustomerRequest = zod_1.z.object({
    id: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    phoneNumber: zod_1.z.string(),
    email: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    notes: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    companyName: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    addresses: zod_1.z.array(address_types_1.CreateNewAddressSchema),
});
exports.CreateCustomerResponse = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
    }),
});
exports.GetCustomersQuery = zod_1.z.object({
    name: zod_1.z.string().optional(),
    address: zod_1.z.string().optional(),
    phoneNumber: zod_1.z.string().optional(),
    email: zod_1.z.string().optional(),
});
exports.CustomerSchema = zod_1.z.object({
    id: zod_1.z.string(),
    previousVersionId: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    phoneNumber: zod_1.z.string(),
    email: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    notes: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    companyName: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    addresses: zod_1.z.array(address_types_1.NewAddressSchema),
});
exports.GetCustomersResponse = zod_1.z.object({
    data: zod_1.z.array(exports.CustomerSchema),
});
exports.CustomerDetailsParams = zod_1.z.object({
    id: zod_1.z.string(),
});
exports.GetCustomerResponse = zod_1.z.object({
    data: exports.CustomerSchema,
});
exports.GetCustomerQuery = zod_1.z.object({
    disabled: zod_1.z.boolean().optional(),
});
exports.UpdateCustomerRequest = exports.CreateCustomerRequest;
exports.UpdateCustomerResponse = exports.GetCustomerResponse;
exports.DeleteCustomerResponse = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
    }),
});
